<div class="editable-table h-100 d-flex flex-column">
    <div class="et-header d-flex gap-2 align-items-center p-3 border-bottom">

        <div class="flex-grow-1">
            <input type="checkbox" [(ngModel)]="isSelectAll" (change)="onSelectAllRows($event)">
            <span> Select All </span>
        </div>

        <!-- Delete Button -->
        <button 
            class="btn btn-danger btn-sm"
            [disabled]="getSelectionCount() ? false : true"
            (click)="onDelete()"
        >
            <img src="assets/images/virtusa-icons/delete-red.svg" alt="Delete" />
            Delete {{ getSelectionCount() }}
        </button>

        <!-- Insert Button with Dropdown -->
        <div class="dropdown">
            <button 
                class="btn btn-primary btn-sm dropdown-toggle"
                type="button"
                id="insertDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                 <img
                src="assets/images/virtusa-icons/insert-row.svg"
                alt="Insert row"
              />
                Insert
            </button>
            <ul class="dropdown-menu" aria-labelledby="insertDropdown">
                <li><a class="dropdown-item" (click)="insert('column')"> Column </a></li>
                <li><a class="dropdown-item" (click)="insert('row')"> Row </a></li>
            </ul>
        </div>

        <!-- Save Button -->
        <button 
            class="btn btn-primary btn-sm"
            (click)="onSave()"
        >
            <img
                src="assets/images/virtusa-icons/save-icon.svg"
                alt="Save"
              />
            Save
        </button>
    </div>
    <div class="et-content">
        <app-zorro-table
            tableId="et-dt-source"
            class="w-100"
            [columns]="tableData.columns"
            [data]="tableData.data"
            [meta]="meta"
            [options]="options"
            [autocompleteOptions]="autocompleteOptions"
            [isLoading]="isLoading"
            (handleActions)="onTableAction($event)"
            (onRowSelect)="onTableRowSelect($event)"
        >
        </app-zorro-table>
    </div>
</div>
